import React from "react";
import "./Shimmer.css"; // Add styles for shimmer effect

const Shimmer = ({ width = "100%", height = "20px", borderRadius = "4px" }) => {
  return (
    <div
      className="shimmer"
      style={{
        width,
        height,
        borderRadius,
      }}
    ></div>
  );
};

export default Shimmer;
